// Google Analytics 4 helpers (tag loaded in __root head).
type Gtag = (...args: unknown[]) => void;

// GA4 event -> Meta Pixel standard event.
const META_EVENTS: Record<string, string> = {
  whatsapp_click: "Contact",
  schedule_meeting: "Schedule",
  generate_lead: "Lead",
};

export function track(event: string, params: Record<string, unknown> = {}) {
  if (typeof window === "undefined") return;
  const w = window as unknown as { gtag?: Gtag; fbq?: Gtag };
  if (w.gtag) w.gtag("event", event, params);
  const meta = META_EVENTS[event];
  if (meta && w.fbq) {
    const eventID = `${event}-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
    w.fbq("track", meta, {}, { eventID });
  }
}

/** Builds the WhatsApp message so the team sees which page the lead came from. */
export function buildWhatsAppMessage(original: string, path: string, pageName: string): string {
  const url = `https://op2p.ai${path === "/" ? "" : path}`;
  const generic = !original.trim() || /estou no site https?:\/\/op2p\.ai e gostaria de conversar/i.test(original);
  if (path === "/" && generic) {
    return `Olá! Estou no site da OP2P (${url}) e gostaria de mais informações sobre o CRM com Agentes de IA.`;
  }
  const where = pageName ? `na página "${pageName}" (${url})` : `na página ${url}`;
  if (generic) return `Olá! Estou ${where} e gostaria de mais informações.`;
  return `${original.trim()}\n\nEstou ${where}.`;
}

function pageName(): string {
  const h1 = document.querySelector("main h1, h1")?.textContent?.replace(/\s+/g, " ").trim();
  if (h1) return h1.slice(0, 120);
  return (document.title.split("|")[0] ?? "").trim().slice(0, 120);
}

/** Tracks WhatsApp clicks site-wide and rewrites the message with the source page. */
export function installWhatsAppTracking() {
  if (typeof window === "undefined") return () => {};
  const onClick = (e: MouseEvent) => {
    const a = (e.target as HTMLElement | null)?.closest?.("a[href*='wa.me']") as HTMLAnchorElement | null;
    if (!a) return;
    const path = window.location.pathname;
    const name = pageName();
    try {
      const url = new URL(a.href);
      if (!a.dataset['origText']) a.dataset['origText'] = url.searchParams.get("text") ?? "";
      url.searchParams.set("text", buildWhatsAppMessage(a.dataset['origText'], path, name));
      a.href = url.toString();
    } catch {
      /* ignore */
    }
    const linkText = a.textContent?.trim().slice(0, 80) ?? "";
    track("whatsapp_click", { page_path: path, link_text: linkText });
    void import("@/integrations/supabase/client").then(({ supabase }) =>
      (supabase as unknown as { from: (t: string) => { insert: (r: object) => Promise<unknown> } }).from("whatsapp_clicks").insert({ path: path.slice(0, 300), page_title: name, link_text: linkText }),
    ).catch(() => {});
  };
  document.addEventListener("click", onClick, true);
  return () => document.removeEventListener("click", onClick, true);
}
